/**
 * @file richtextcomponent.js
 * @description Rich Text Editor component for displaying and managing rich text content.
 * @component RichTextEditor
 * @exports RichTextEditor - Main component for rich text editing.
 */

import React, { useState, useEffect, useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

function RichTextEditor({ value, onChange, disabled }) {
  const [editorContent, setEditorContent] = useState(value);
  const quillRef = useRef(null); // Reference to ReactQuill

  useEffect(() => {
    setEditorContent(value);
  }, [value]);

  useEffect(() => {
    if (quillRef.current) {
      const editor = quillRef.current.getEditor(); // Get the Quill instance
      if (disabled) {
        editor.disable(); // Disable editor
      } else {
        editor.enable(); // Enable editor
      }
    }
  }, [disabled]); // Re-run when `disabled` changes

  const handleContentChange = (newValue) => {
    setEditorContent(newValue);
    onChange(newValue);
  };

  return (
    <ReactQuill
      ref={quillRef} // Attach ref to the editor
      value={editorContent}
      onChange={handleContentChange}
      theme="snow"
      placeholder="Start editing here..."
      className="ai-rte"
    />
  );
}

export default RichTextEditor;
